import logo from '../../assets/koc-logo-footer.png';

const Footer = () => {
    return (
        <div className='app-footer'>
            <img src={logo} alt="KocAilem" />
        </div>
    )
}

export default Footer